/** Шрифты для canvas-отрисовки */
export const FONTS = {
    /** Основной текст нотификации */
    text: '500 16px "YS Text", sans-serif',
    /** Текст DTMF-команды в круге */
    dtmfCommand: '500 13.36px "YS Text", sans-serif',
} as const;
